import { createSlice } from '@reduxjs/toolkit';

const collectionSlice = createSlice({
  name: 'collection',
  initialState: [],
  reducers: {
    updateCollection: (state, action) => action.payload,
  },
});

export const { updateCollection } = collectionSlice.actions;
export default collectionSlice.reducer;